import simplify from "simplify-js";

export function simplifyCurve(points: number[][], tolerance = 3, highQuality = false): number[][] {

    return simplify(points.map(p => ({ x: p[0], y: p[1] })), tolerance, highQuality).map(p => [p.x, p.y])
}